import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login/login.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import moment from 'moment';
@Component({
  selector: 'app-disabled-work-page',
  templateUrl: './disabled-work-page.component.html',
  styleUrls: ['./disabled-work-page.component.css']
})
export class DisabledWorkPageComponent implements OnInit {
  currentPage: number = 1;
  AllocationFlag:any=false
  itemsPerPage: number = 25;
  status:any='Disabled'
  totalItems: number =0
  Alllocations:any=[]
  selectedlocations:any=[]
  dropdownSettingslocation = {
    singleSelection: false,
    idField: 'item',
    textField: 'item',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  tableSize: number[] = [5, 10, 20, 50, 100];
  pagingConfig: any = {}
  pageNo: any;
  size: any;
  searchQuery:any=''
  disabledCases:any=[]
  sortOrder: 'asc' | 'desc' = 'asc';
  sortField: string = ''; // Tracks the current field being sorted
  currentCount:any=0
  total:any=0
  token:any
  disabled:any=true
  currentSortColumn:any=''
  storedData:any

   dropdownSettingsBuisness:any;
  dynamicFilter:any;
   selectedBuisnessNatures:any = []
 buisnessNatures:any = []

  constructor(private loginService:LoginService,private router:Router) { this.pagingConfig = {
    itemsPerPage: this.itemsPerPage,
    currentPage: this.currentPage,
    totalItems: this.totalItems
  } }

  ngOnInit(): void {

    if(localStorage.getItem('disableStatus')){
      this.status = localStorage.getItem('disableStatus')
         
    }else{
        this.status='Disabled'
    }
    this.token = localStorage.getItem('token');
    this.storedData= JSON.parse(localStorage.getItem("user") || '{}');
   
    const locations = localStorage.getItem('selectedlocations');
     if (locations) {
      this.selectedlocations = JSON.parse(locations);
    }

    const buisnessNatures =  localStorage.getItem('selectedBuisnessNatures');

     if (buisnessNatures && buisnessNatures !== 'undefined' && buisnessNatures !== 'null') {
      try {
        this.selectedBuisnessNatures = JSON.parse(buisnessNatures);
        console.log(this.selectedBuisnessNatures)
      } catch (e) {
        console.error('Invalid JSON in selectedbuisness:', e);
        this.selectedlocations = [];
      }
    } else {
      this.selectedBuisnessNatures = [];
    }

      if(localStorage.getItem('currentPage')){
         this.pagingConfig.currentPage = localStorage.getItem('currentPage');
         localStorage.removeItem('currentPage');
    }

    if(this.status=='Disabled'){
      this.listDisabledCases()
    }else{
      this.listClientsForSupervisor()

    }
    // this.listDisabledCases()
    this.listSingleAgency()
  }

   searchTimer: any;
  onSearchChange(value: string) {

  clearTimeout(this.searchTimer);

  this.searchTimer = setTimeout(() => {

    // Empty → normal listing
    if (!value || value.trim().length === 0) {

      this.searchQuery = '';
      this.pagingConfig.currentPage = 1;
       if(this.status=='Disabled'){
          this.listDisabledCases()
        }else{
          this.listClientsForSupervisor()

        }
      return;

    }

    // Search only when 3+ chars
    if (value.trim().length >= 3) {

      this.pagingConfig.currentPage = 1;
      // this.listCases();
       if(this.status=='Disabled'){
          this.listDisabledCases()
        }else{
          this.listClientsForSupervisor()

        }

    }

  }, 500); // wait 500ms after typing stops

}
  onTableSizeChange(event: any): void {
    this.pagingConfig.itemsPerPage = event.target.value;
    this.pagingConfig.currentPage = 1;
    this.size = event.target.value

    if(this.status=='Disabled'){
      this.listDisabledCases()
    }else{
      this.listClientsForSupervisor()

    }
    

  }

 resetFilter(){
     this.selectedlocations = [];
     this.status = [];
     this.saveFilters();
     this.listDisabledCases();
 }

  onTableDataChange(event: any) {
    this.pagingConfig.currentPage = event;
   
    if(this.status=='Disabled'){
      this.listDisabledCases()
    }else{
      this.listClientsForSupervisor()

    }  }
  listDisabledCases(){
    console.log(this.status)

    let req={
      searchKey:this.searchQuery,

      page:this.pagingConfig.currentPage,
      limit:this.pagingConfig.itemsPerPage
    }


    let body={
      status:this.status,
      userType:this.storedData.userType[0].userType,
      location:this.selectedlocations,
       dynamicFilter:this.dynamicFilter
    }


      this.loginService.listDisabledCases(this.token,req,body)
                .subscribe((response: any) => {
                  if (response.status === 1) {


                         this.disabledCases=response.data

                    // this.disabledCases = this.disabledCases.map((item: any) => {
                    //         // case 1: clientRefId is an object
                    //         if (item.clientRefId && typeof item.clientRefId === 'object') {
                    //           const clientRef = { ...item.clientRefId };

                    //           // remove unwanted properties
                    //           delete clientRef.status;
                    //           delete clientRef.teleCallerId;
                    //               // delete clientRef.updatedBy;
                    //                       // delete clientRef.initiatedBy;

                    //       delete  clientRef.products
                    //      delete clientRef._id;

                    //           console.log(item._id,item.clientRefId.clientName)

                    //           return {
                    //             ...item,
                    //             clientRefId: clientRef.clientRefId,
                    //             location:clientRef.location,
                    //             disableReason:clientRef.disableReason||item.disableReason,
                    //             disabledBy:clientRef.disabledBy||item.disabledBy,
                    //             disabledAt:clientRef.disabledAt||item.disabledAt,
                    //             productId: item._id,
                    //             // keep all products
                    //             ...clientRef
                    //           };
                    //         }

                    //         // case 2: clientRefId is a string (just return item with productId)
                    //         return {
                    //           ...item,
                    //         };
                    //       });
                         this.pagingConfig.totalItems = response.totalCount;
                          this.currentCount=response.data.length
                         this. total=response.totalCount
                  }})
  }
  // ClientDetail(flag:any,obj:any){
  //   obj.flag=flag
  //   localStorage.setItem('Work',JSON.stringify(obj))
  //   this.router.navigate(["/add-work-page"])

  // }

  ClientDetail(flag: any, obj: any) {


     localStorage.setItem('currentPage' ,this.pagingConfig.currentPage)

    console.log("objjjjjjj" , obj._id)
      obj.flag = flag;
      obj.productId=obj._id
      localStorage.setItem('Work', JSON.stringify(obj));
    
    
      if (this.storedData.userType[0].userType=='Backend Staff' || this.storedData.userType[0].userType=='Tele Caller') {
       let data={
        userId:this.storedData._id,
  
       }
      
        this.loginService.checkPunchStatus(this.token,data).
        subscribe((response: any) => {
          if (response.result.length>0) {
if(obj&&obj.status&&obj.status !== 'New case' && obj.status !== 'Under Validation' && obj.status !== 'Verified'){
        localStorage.setItem('Work', JSON.stringify(obj));
           
  this.router.navigate(["/productwise-detail"]);


      }
      else{
      this.router.navigate(["/add-work-page"]);

      }         
       } else {
            // alert('Please punch in before proceeding.');
            Swal.fire({
              title: 'UnAuthorized',
              text: "Please Punch In!!!!",
              icon: 'warning',
                    })
          }
        }
      )
      } else {
if(obj&&obj.status&&obj.status !== 'New case' && obj.status !== 'Under Validation' && obj.status !== 'Verified'){

            console.log(obj)
              this.router.navigate(["/productwise-detail"]);


      }else{
      this.router.navigate(["/add-work-page"]);

      }        }
    }
  
  formatDate(isoDate: string): string {
    if(isoDate){
      const date = new Date(isoDate);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }else{
      return ''
    }
  
  }


   disable(eachCase: any) {
  
  
      Swal.fire({
        title: 'Disable File?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        html: `
            <textarea id="commentTextarea" class="swal2-textarea" 
              maxlength="58" 
  
            placeholder="Enter your comments here..." style="width: 100%; height: 100px;
           margin:0px">
          `,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        preConfirm: () => {
          // Fetch the comment entered in the textarea
          var comment = (document.getElementById('commentTextarea') as HTMLTextAreaElement)?.value;
          console.log(comment.length);
  
          comment = comment.trimStart()
  
          if (!comment || comment.length > 58) {
            Swal.showValidationMessage('Please enter a comment max 15 length');
            return false;
          }
  
          return { comment }; // Pass the comment for further use
        }
      }).then((result) => {
        if (result.isConfirmed) {
          result.value.comment = result.value.comment.trimStart()
          let request = {
            id: eachCase._id,
            status: eachCase.status,
            disableReason: result.value.comment?.toUpperCase(),
  
          }
  
          this.loginService.updateActiveStatus(this.token, request)
            .subscribe((response: any) => {
              if (response && response.status === 1) {
                Swal.fire("Success")

                const selectedStatus=this.status
                    let req={
                      searchKey:this.searchQuery,
                
                      page:this.pagingConfig.currentPage,
                      limit:this.pagingConfig.itemsPerPage
                    }
                
                
                    let body={
                      status:selectedStatus,

                      userType:this.storedData.userType[0].userType,
                      products:this.storedData.products,

                    }
    
             
                   this.loginService.listClientsForSupervisor(this.token,req,body)
                    .subscribe((response: any) => {
                      if (response.status === 1) {
                              this.disabledCases=response.data
                              this.pagingConfig.totalItems =response.totalCount;
                              this.currentCount=response.data.length
                              this. total=response.totalCount
                      }})
  
  
              } else {
                Swal.fire(response.errorDetails)
              }
  
            })
  
        }
      })
  
  
    }



    copyText(text: string) {
        // navigator.clipboard.writeText(text);
        // alert(`Copied: ${text}`);
  
         navigator.clipboard.writeText(text).then(
          () => {
              const Toast = Swal.mixin({
                    toast: true,
                    position: "center",
                    showConfirmButton: false,
                    timer: 1500,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                      toast.onmouseenter = Swal.stopTimer;
                      toast.onmouseleave = Swal.resumeTimer;
                    }
                  });
                  Toast.fire({
                    icon: "success",
                    title: "Code copied to clipboard"
                  });
  
          },
          (err) => {
            console.error('Could not copy text: ', err);
          }
        );
  }

  // sortTable(column: string): void {

  //   if (this.currentSortColumn === column) {
  //     // Toggle the sort order if the column is already sorted
  //     this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
  //   } else {
  //     // Set the column to the current sort column and default to ascending
  //     this.currentSortColumn = column;
  //     this.sortOrder = 'asc';
  //   }
  //   this.showingCases.sort((a:any, b:any) => {
  //     let valueA = this.getValueByPath(a, column);
  //     let valueB = this.getValueByPath(b, column);

  //     if (valueA < valueB) return this.sortOrder === 'asc' ? -1 : 1;
  //     if (valueA > valueB) return this.sortOrder === 'asc' ? 1 : -1;
  //     return 0;
  //   });
  // }

   

      enable(eachCase:any){
        


         Swal.fire({
          title: "Are you sure?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Proceed!"
        }).then((result) => {
          if (result.isConfirmed) {

             let request:any;
            if(eachCase.status=='Verified' || eachCase.status=='New case' || eachCase.status=='Under Validation'){
                 request={
                  id:eachCase._id,
                  status:eachCase.status,
                  isActive:true
                }
            }else{
                request={
                  id:eachCase._id,
                  status:eachCase.status,
                   isActive:true
                }
            }
  
              
          
                this.loginService.updateActiveStatus(this.token,request)
                .subscribe((response: any) => {
                if (response&&response.status === 1) {
                  Swal.fire("Success")
                  this.listDisabledCases()  
          
                }else{
                  Swal.fire(response.errorDetails)
                }
              })
       
            }
          });
  
      }


      sortTable(column: string): void {
       this.sortField=column
        if (this.currentSortColumn === column) {
          // Toggle the sort order if the column is already sorted
          this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
          // Set the column to the current sort column and default to ascending
          this.currentSortColumn = column;
          this.sortOrder = 'asc';
        }
      
        this.disabledCases.sort((a: any, b: any) => {
          let valueA = this.getValueByPath(a, column);
          let valueB = this.getValueByPath(b, column);
      
          // Handle null or undefined values
          if (valueA == null) return this.sortOrder === 'asc' ? 1 : -1;
          if (valueB == null) return this.sortOrder === 'asc' ? -1 : 1;
      
          // Attempt to parse dates
          const dateA = this.parseCustomDate(valueA);
          const dateB = this.parseCustomDate(valueB);
      
          if (dateA && dateB) {
            // Compare as dates
            if (dateA < dateB) return this.sortOrder === 'asc' ? -1 : 1;
            if (dateA > dateB) return this.sortOrder === 'asc' ? 1 : -1;
            return 0;
          }
      
          // Compare as numbers if both are numeric
          if (!isNaN(valueA) && !isNaN(valueB)) {
            valueA = Number(valueA);
            valueB = Number(valueB);
            return this.sortOrder === 'asc' ? valueA - valueB : valueB - valueA;
          }
      
          // Compare as strings (case insensitive)
          valueA = String(valueA).toLowerCase();
          valueB = String(valueB).toLowerCase();
          if (valueA < valueB) return this.sortOrder === 'asc' ? -1 : 1;
          if (valueA > valueB) return this.sortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }








      listSingleAgency(){
        this.loginService.listSingleAgency(this.token,this.storedData.agencyRefId._id)
        .subscribe((response: any) => {
            if (response.status === 1) {
              this.Alllocations=response.data[0].location[0].valueList
              this.Alllocations =  this.Alllocations.map((status :any)=> ({ item: status }));
      
                   let tempB:any = response.data[0].clientQuestion.filter((s:any) => s.field === 'Business_Nature');
                    this.buisnessNatures = tempB[0].valueList

                      this.dropdownSettingsBuisness = {
                        singleSelection: false,
                        idField: 'item',
                        textField: 'item',
                        itemsShowLimit: 1,
                        allowSearchFilter: true
                      };

          }})
      
      }
      Pushlocation(event:any){
        this.selectedlocations = this.selectedlocations.map((item: any) => item.item);
        this.saveFilters();
        if(this.status=='Disabled'){
          this.listDisabledCases()
        }else{
          this.listClientsForSupervisor()
    
        }
              
      
      }

 onSelectField(){
      console.log(this.selectedBuisnessNatures)
      this.dynamicFilter = {
          "displayName":"Business Nature",
          "value" : this.selectedBuisnessNatures
      }
       this.saveFilters();
    this.listDisabledCases();
  }

   onDeSelectField(event:any){
      console.log(this.selectedBuisnessNatures)
      this.dynamicFilter = {
          "displayName":"Business Nature",
          "value" : this.selectedBuisnessNatures
      }
      
     this.listDisabledCases();
  }

    onselctAllB(selected:any[]){

    console.log(this.selectedBuisnessNatures)
    this.selectedBuisnessNatures = selected;
      this.dynamicFilter = {
          "displayName":"Business Nature",
          "value" : this.selectedBuisnessNatures
      }
       this.saveFilters();
      this.listDisabledCases();
  }

   onDeselctAllB(event:any){

    this.selectedBuisnessNatures = []
      this.dynamicFilter = {
          "displayName":"Business Nature",
          "value" : this.selectedBuisnessNatures
      }
      
     this.listDisabledCases();
  }




 saveFilters() {
  
    localStorage.setItem('selectedlocations', JSON.stringify(this.selectedlocations));
      localStorage.setItem('selectedBuisnessNatures', JSON.stringify(this.selectedBuisnessNatures));
  }

      parseCustomDate(dateString: string): Date | null {
        // Match DD/MM/YYYY
        const ddmmyyyyRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
        const ddmmyyyyMatch = dateString.match(ddmmyyyyRegex);
        if (ddmmyyyyMatch) {
          const [_, day, month, year] = ddmmyyyyMatch.map(Number);
          return new Date(year, month - 1, day);
        }
      
        // Match YYYY-MM-DD
        const yyyymmddRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
        const yyyymmddMatch = dateString.match(yyyymmddRegex);
        if (yyyymmddMatch) {
          const [_, year, month, day] = yyyymmddMatch.map(Number);
          return new Date(year, month - 1, day);
        }
      
        return null; // Return null if no valid date format is detected
      }
      
      // Helper function to get nested values by path
      getValueByPath(obj: any, path: string): any {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
      }
      
      statusChange(event: Event) {

//         const selectedStatus = (event.target as HTMLSelectElement).value;
// this.status=selectedStatus
const selectedStatus=this.status
        let req={
          searchKey:this.searchQuery,
    
          page:this.pagingConfig.currentPage,
          limit:this.pagingConfig.itemsPerPage
        }
    
    
        let body={
          status:selectedStatus,

          userType:this.storedData.userType[0].userType,
          products:this.storedData.products,

        }
    

        localStorage.setItem('disableStatus', selectedStatus);

      
        if (selectedStatus === 'Disabled') {
          this.disabled=true

          this.loginService.listDisabledCases(this.token,req,body)
          .subscribe((response: any) => {
            if (response.status === 1) {
                   this.disabledCases=response.data
                   this.pagingConfig.totalItems = response.totalCount;
                   this.currentCount=response.data.length
                   this. total=response.totalCount
            }})
        } else if (selectedStatus === 'Not Interested') {
          this.disabled=false
       this.loginService.listClientsForSupervisor(this.token,req,body)
       .subscribe((response: any) => {
         if (response.status === 1) {
                this.disabledCases=response.data
                this.pagingConfig.totalItems =response.totalCount;
                this.currentCount=response.data.length
                this. total=response.totalCount
         }})
        } else if (selectedStatus === 'Client Enrolled') {
          this.disabled=false

          this.loginService.listClientsForSupervisor(this.token,req,body)
          .subscribe((response: any) => {
            if (response.status === 1) {
                   this.disabledCases=response.data
                   this.pagingConfig.totalItems =response.totalCount;
                   this.currentCount=response.data.length
                   this. total=response.totalCount
            }})
        } else {
          console.log('Unknown status');
          // Handle any unexpected cases
        }
      }
 
      format(date:any){
           return moment(date).format('DD-MM-YYYY \nHH:mma');
      
      }

      listClientsForSupervisor(){

        let req={
          searchKey:this.searchQuery,
    
          page:this.pagingConfig.currentPage,
          limit:this.pagingConfig.itemsPerPage
        }
    
    
        let body={
          status:this.status,

          userType:this.storedData.userType[0].userType,
          products:this.storedData.products,
          location:this.selectedlocations

        }
    
        this.loginService.listClientsForSupervisor(this.token,req,body)
        .subscribe((response: any) => {
          if (response.status === 1) {
                 this.disabledCases=response.data
                 this.pagingConfig.totalItems = response.totalCount;
                 this.currentCount=response.data.length
                 this. total=response.totalCount
          }})
      }
      getStatusClass(status: string): string {
        switch (status) {
          case 'New case':
            return 'status-new-case';
          case 'Under Validation':
            return 'status-under-validation';
          case 'Verified':
            return 'status-verified';
          case 'Under Telecall':
            return 'status-under-telecall';
          case 'Interested':
            return 'status-interested';
          case 'Not Interested':
            return 'status-not-interested';
          case 'Client Enrolled':
            return 'status-client-enrolled';
          case 'Field Visit':
            return 'status-field-visit';
          default:
            return 'status-default';
        }
      }
       
}
